import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, style, ...props }, ref) => {
  const dir = document.documentElement.getAttribute("dir") || "ltr";
  const isRtl = dir === "rtl";
  const translateValue = 100 - (value || 0);

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn("relative h-2.5 w-full overflow-hidden rounded-full bg-muted/80", className)}
      style={style}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className="h-full w-full flex-1 rounded-full transition-all duration-300 ease-out"
        style={{
          transform: isRtl
            ? `translateX(${translateValue}%)`
            : `translateX(-${translateValue}%)`,
          backgroundColor: 'var(--progress-color, hsl(var(--primary)))'
        }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
